import React, { useEffect, useState } from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import ObservationList from './observation-list'
import ObservationForm from './observation-form'
import "./observation.css"


export default function Observation(props) {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [updateDate, setUpdateDate] = useState(null);
  const handleSelect = (index) => {
    setSelectedIndex(index);
  };


  return<React.Fragment>
     <Tabs selectedIndex={selectedIndex} onSelect={handleSelect}>
                        
                              
                                <TabList>
                                  <Tab >Log observation list</Tab>
                                  <Tab >Log observation form</Tab>
                                </TabList>
                            <div className='row'>
                             
                              <TabPanel>
                               <ObservationList setSelectedIndex={setSelectedIndex} setUpdateDate={setUpdateDate}/>
                              </TabPanel>
                              <TabPanel>
                                <ObservationForm data={props.data} setSelectedIndex={setSelectedIndex} updateDate={updateDate}/>
                              </TabPanel>
                             
                            </div>
                    </Tabs>
  </React.Fragment>
}
